import React, {useState,useEffect} from 'react';
import { useDispatch } from 'react-redux';
import { localLogin, validateUser } from '../../actions/ChatRoom'

const SignIn = () => {

    const dispatch = useDispatch();
    const [first, setFirst] = useState('');
    const [last, setLast] = useState('');
    const [error, setError] = useState('');

    // Check Storage for user
    useEffect(() => { 

        // Get Configuration
        dispatch(validateUser());

    }, []);
    

    const handleSignIn = () => {

        // Validate
        if(!first || !last) {
            setError('Please enter a first and last name');
            return;
        }

        // Set
        const username = first + ' ' + last;
        dispatch(localLogin(username));
    }


    return (
        <div className="groupchat-signin">
            {error && (<div class="error">{error}</div>)}
            <input name="first" placeholder="First Name" type="text" value={first} onChange={(e) => setFirst(e.target.value)} />
            <input name="last" placeholder="Last Name" type="text" value={last} onChange={(e) => setLast(e.target.value)} />
            <button onClick={handleSignIn}>Join</button>
        </div>
    )
}

export default SignIn;